import { useContext, useEffect } from 'react';


import { UserContext } from '../components/provider';
const {REACT_APP_BASE_BACKEND_URL, REACT_APP_NUMBER_COURSE_PER_PAGE} = process.env;


export const getMe = () => {
    const token = window.localStorage.getItem('jwt');
    fetch(REACT_APP_BASE_BACKEND_URL + '/accounts/auth/get-current-user', {
        method: 'GET',
        credentials: 'include',
        headers: { 
            'Content-Type': 'application/json',
            'Authorization': `${token && `jwt ${token}`}`
        }
        })
        .then(response => {
            if (response.status === 204) {
                localStorage.removeItem('session_id');
                return ;
            }
            return response.json()
        })
        .then(data => {
            if (data) {
                return true;
            }
        });
};

export const useUserRequired = () => {
  const { user, setUser } = useContext(UserContext);

  useEffect(() => {
    console.log('use user');
    if (!user.email) {
        console.log('no user');
        getMe()
    }
  }, [user, setUser]);
};
